module.exports = "https://www.gc-pro.gnp.com.mx/b55a6809104c47581a898fcc3aa2b960.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bullet.svg
// module id = 8065
// module chunks = 0